import _default from './Statistic';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/views/Statistic/index.js
// module id = 711
// module chunks = 0